import { render, staticRenderFns } from "./access-control-user-item.vue?vue&type=template&id=2c87408c&scoped=true&"
import script from "./access-control-user-item.vue?vue&type=script&lang=js&"
export * from "./access-control-user-item.vue?vue&type=script&lang=js&"
import style0 from "./access-control-user-item.vue?vue&type=style&index=0&id=2c87408c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c87408c",
  null
  
)

export default component.exports